// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOperationsPinRemove = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.818 8.525 5.176 3.884a.25.25 0 0 1 0-.354l.354-.353a.25.25 0 0 1 .353 0L20.35 17.643a.25.25 0 0 1 0 .354l-.354.354a.25.25 0 0 1-.353 0l-4.169-4.169-.525.525a2.997 2.997 0 0 0-.578 3.433c.241.496.262 1.127-.129 1.517a1 1 0 0 1-1.414 0L9.27 16.1l-4.657 4.657A1 1 0 0 1 3.2 19.343l4.657-4.657-3.514-3.514a1 1 0 0 1 0-1.415c.39-.39 1.02-.37 1.517-.128a2.997 2.997 0 0 0 3.432-.579zm1.414 1.414-.525.526a4.943 4.943 0 0 1-2.829 1.414l4.243 4.242a4.986 4.986 0 0 1 1.414-2.828l.525-.525zm3.01-3.01-1.265 1.265-1.414-1.415 1.265-1.264-.707-.707a1.003 1.003 0 0 1 0-1.415 1.003 1.003 0 0 1 1.414 0l7.071 7.072a1.003 1.003 0 0 1 0 1.414 1.003 1.003 0 0 1-1.414 0l-.707-.707-1.265 1.264-1.414-1.414 1.265-1.265z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgOperationsPinRemove;
